import './event-listing-card.html.twig';
import './event-listing-card.scss';

export default function () {
  const cards = document.querySelectorAll('.event-listing-card');

  if (!cards) {
    return;
  }

  // Attaching the click event on the image (if it exists) as the click
  // on the body is handled via css (see a::after rule)
  cards.forEach((card) => {
    const link = card.querySelector('.event-listing-card__title a');
    const cardImage = card.querySelector('.event-listing-card__image-wrapper');
    if (cardImage) {
      cardImage.addEventListener('click', () => {
        link.click();
      });
    }
  });
};